<section class="content-box">
  <div class="text">
    <h1>
      <ui-icon faName="lock" faStyle="light"></ui-icon>
      Ihr Zugang ist aktuell gesperrt
    </h1>
    <p>Sie können deshalb keine Bestellungen platzieren. Bitte wenden Sie sich an Ihre:n Lekkerland
      Ansprechpartner:in.</p>
  </div>
  <img [src]="'/assets/img/user-blocked/mr-lekker-attention.svg' | formatAbsolute" alt="Lekkerland Mr.Lekker" />
</section>

